import React from 'react';
import { IPopover2Props } from './Popover2';
import { IObfuscationProps, Obfuscation } from '@synerg/vdl-react-components';
import { MDFOverlayContent } from './MDFOverlayPopover';

export interface IMDFObfuscationProps extends IObfuscationProps {
  revealText?: string;
}

export class MDFMaskContent extends React.Component<IPopover2Props, any> {
  render() {
    return <div>{this.props.children}</div>;
  }
}

export const MDFObfuscationComponent = (props: IMDFObfuscationProps) => {
  let maskContent: MDFMaskContent = null;
  let overlay: MDFOverlayContent = null;

  React.Children.forEach(props.children, (child: any): any => {
    if (child.type === MDFMaskContent) {
      maskContent = child;
    }
    else if (child.type === MDFOverlayContent) {
      overlay = child;
    }
  });

  if (!maskContent || !overlay) {
    return null;
  }

  const { revealText, ...rest } = props;

  return (
    <div className="mdf-obfuscation">
      <Obfuscation mask={maskContent.props.children as any} value={overlay.props.children} {...rest}>
      </Obfuscation>
      <span className="mdf-obfuscation__reveal-text">{revealText}</span>
    </div>
  );
};
